import {defineMessages} from 'react-intl'

export const messages = defineMessages({
  toastText: {
    id: 'dealFreezeToast.titleWithCta',
    defaultMessage: 'Freeze a deal. Decide later. <span>View deals</span>'
  },
  toastDismissAriaLabel: {
    id: 'close',
    defaultMessage: 'Close'
  },
  filterExplanationBody: {
    id: 'dealFreezeToast.freezableTooltip',
    defaultMessage:
      'Only shows deals eligible for Deal Freeze — hold the room and price while you decide. No card details required.'
  }
})
